import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "agreement" }
const _hoisted_2 = { class: "pair font-greek" }
const _hoisted_3 = { class: "n" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 1,
  class: "zero"
}
const _hoisted_6 = { class: "n share" }
const _hoisted_7 = { class: "n muted" }
const _hoisted_8 = {
  key: 0,
  class: "evidence-row"
}
const _hoisted_9 = { colspan: "8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EvidenceList = _resolveComponent("EvidenceList")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
      _createElementVNode("tr", null, [
        _createElementVNode("th", null, "Columns"),
        _createElementVNode("th", { title: "MT morphemes both render" }, "Both"),
        _createElementVNode("th", { title: "One reading attributed to both" }, "Joint"),
        _createElementVNode("th", { title: "Separate readings, a word in common" }, "Same"),
        _createElementVNode("th", { title: "Nothing in common" }, "Different"),
        _createElementVNode("th", { title: "Agree where the LXX renders otherwise" }, "vs LXX"),
        _createElementVNode("th", { title: "Of separately attested readings, the share with a word in common" }, "Agree"),
        _createElementVNode("th", { title: "Apparatus lemmas with readings of both" }, "Lemmas")
      ])
    ], -1)),
    _createElementVNode("tbody", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pairs, (p) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: `${p.a}|${p.b}`
        }, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_2, _toDisplayString(p.a) + " · " + _toDisplayString(p.b), 1),
            _createElementVNode("td", _hoisted_3, _toDisplayString(p.shared), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.counted, (r) => {
              return (_openBlock(), _createElementBlock("td", {
                key: r,
                class: "n"
              }, [
                (p[r])
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: _normalizeClass(["count", { 'is-open': _ctx.isOpen(p, r) }]),
                      onClick: ($event: any) => (_ctx.toggle(p, r))
                    }, _toDisplayString(p[r]), 11, _hoisted_4))
                  : (_openBlock(), _createElementBlock("span", _hoisted_5, "0"))
              ]))
            }), 128)),
            _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.percent(p.independent_agreement)), 1),
            _createElementVNode("td", _hoisted_7, _toDisplayString(p.co_attested), 1)
          ]),
          (_ctx.open && _ctx.open.a === p.a && _ctx.open.b === p.b)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                _createElementVNode("td", _hoisted_9, [
                  (_openBlock(), _createBlock(_component_EvidenceList, {
                    key: `${p.a}|${p.b}|${_ctx.open.relation}`,
                    a: p.a,
                    b: p.b,
                    relation: _ctx.open.relation,
                    scope: _ctx.scope
                  }, null, 8, ["a", "b", "relation", "scope"]))
                ])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ])
  ]))
}